import { render, staticRenderFns } from "./NotificationSnapshot.vue?vue&type=template&id=1cc7d459&scoped=true&"
import script from "./NotificationSnapshot.vue?vue&type=script&lang=ts&"
export * from "./NotificationSnapshot.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationSnapshot.vue?vue&type=style&index=0&id=1cc7d459&lang=scss&scoped=true&"
import style1 from "./NotificationSnapshot.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7d459",
  null
  
)

export default component.exports